/* Dongar Classic — tabbed picker controller.
   Wires up:
     - Tab switching (Find by vehicle ↔ Browse all variants) with localStorage recall
     - Tile click → drives the hidden Shopify <variant-selects> <select>
     - On variant change → updates the Amazon button URL from window.PDPC_AMAZON
     - Vehicle finder (make → year → model) hitting compatibility-api.
       When the result SKU matches one of this product's variants, auto-switch
       to the Browse tab and select the matching tile. Otherwise show a
       "this needs a different product" redirect card.
*/
(function () {
  'use strict';

  var API_BASE = 'https://vdfgvxqwcjdupvtjhnmy.supabase.co/functions/v1/compatibility-api';
  // Anon key — same one used by sections/device-compatibility.liquid. Read-only,
  // and the function itself uses service_role server-side.
  var ANON = (window.PDPC_CONFIG && window.PDPC_CONFIG.anon) || '';

  function api(params) {
    var u = new URL(API_BASE);
    Object.keys(params).forEach(function (k) {
      if (params[k] !== undefined && params[k] !== null && params[k] !== '') {
        u.searchParams.set(k, params[k]);
      }
    });
    return fetch(u.toString(), {
      headers: ANON ? { 'apikey': ANON, 'Authorization': 'Bearer ' + ANON } : {}
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init(root) {
    if (root.dataset.pdpcInit === '1') return;
    root.dataset.pdpcInit = '1';

    var sectionId = root.dataset.sectionId;
    var host = document.getElementById('MainProduct-' + sectionId) || document;
    host.classList.add('pdpc-host');

    var tabs   = $$('.pdpc-tab', root);
    var panels = $$('.pdpc-panel', root);

    // ── Tabs ───────────────────────────────────────────────────────────
    // Single-variant products render only the Finder panel (no tabs, no
    // Browse) — skip all tab-switching machinery in that case.
    function setTab(name, persist) {
      tabs.forEach(function (t) {
        var on = t.dataset.pdpcTab === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) {
        p.dataset.active = p.dataset.pdpcPanel === name ? 'true' : 'false';
      });
      if (persist) {
        try { localStorage.setItem('pdpc_tab', name); } catch (e) { /* ignore */ }
      }
    }
    if (tabs.length >= 2) {
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { setTab(t.dataset.pdpcTab, true); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault();
            var i = tabs.indexOf(t);
            var next = e.key === 'ArrowRight'
              ? tabs[(i + 1) % tabs.length]
              : tabs[(i - 1 + tabs.length) % tabs.length];
            next.focus();
            setTab(next.dataset.pdpcTab, true);
          }
        });
      });
      var saved = null;
      try { saved = localStorage.getItem('pdpc_tab'); } catch (e) { /* ignore */ }
      setTab(saved && (saved === 'finder' || saved === 'browse') ? saved : 'finder', false);
    } else {
      // Single panel — make sure Finder is visible regardless of any
      // stale localStorage value pointing at 'browse'.
      panels.forEach(function (p) {
        p.dataset.active = p.dataset.pdpcPanel === 'finder' ? 'true' : 'false';
      });
    }

    // ── Tiles → drive the hidden Shopify <variant-selects> ──────────────
    // <variant-selects> wraps one <select> per option (option1/option2/option3).
    // Each select.value is the OPTION value (e.g. "Harness 3A"), not the variant
    // ID; the controller derives the variant from the option combination on
    // change. So tile-click → set each option-select to the variant's option
    // value → dispatch change → controller updates price, gallery, and form.
    var optionSelects = $$('variant-selects select, variant-radios select', host);
    var tiles = $$('.pdpc-tile', root);

    function selectTile(variantId, opts) {
      var tile = null;
      tiles.forEach(function (t) {
        var on = t.dataset.variantId === String(variantId);
        t.dataset.selected = on ? 'true' : 'false';
        if (on) tile = t;
      });
      if (!tile) return;
      var changed = false;
      optionSelects.forEach(function (sel, i) {
        var key = 'option' + (i + 1);
        var v = tile.dataset[key];
        if (v !== undefined && sel.value !== v) {
          sel.value = v;
          changed = true;
        }
      });
      if (changed) {
        // Dispatch on the last select so variant-selects re-evaluates.
        optionSelects.forEach(function (sel) {
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      updateAmazonForVariant(variantId);
      if (opts && opts.scroll) {
        var buyBox = $('.pdpc-buybar-wrap', host) || $('.product-form__buttons', host) || root;
        if (buyBox && buyBox.scrollIntoView) {
          buyBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }

    function currentVariantIdFromOptions() {
      // Walk the tiles; the one whose option1/2/3 match the current selects wins.
      for (var i = 0; i < tiles.length; i++) {
        var t = tiles[i];
        var match = true;
        for (var j = 0; j < optionSelects.length; j++) {
          var key = 'option' + (j + 1);
          if (t.dataset[key] !== optionSelects[j].value) { match = false; break; }
        }
        if (match) return t.dataset.variantId;
      }
      return null;
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        if (tile.dataset.available === 'false') {
          // Allow selection of sold-out variants (Shopify will block ATC).
        }
        selectTile(tile.dataset.variantId);
      });
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectTile(tile.dataset.variantId);
        }
      });
    });

    // Mirror initial state from the option selects (selected_or_first_available).
    var initialVariantId = currentVariantIdFromOptions();
    if (initialVariantId) {
      tiles.forEach(function (tile) {
        tile.dataset.selected = tile.dataset.variantId === initialVariantId ? 'true' : 'false';
      });
    }

    // When Shopify itself changes the variant (e.g. deep-linked URL or
    // sticky-bar quick-buy), keep the tiles + Amazon button in sync.
    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var v = currentVariantIdFromOptions();
        if (!v) return;
        tiles.forEach(function (tile) {
          tile.dataset.selected = tile.dataset.variantId === v ? 'true' : 'false';
        });
        updateAmazonForVariant(v);
      });
    });

    // ── Amazon button ──────────────────────────────────────────────────
    var amazonMap = (window.PDPC_AMAZON && window.PDPC_AMAZON[sectionId]) || {};
    // SKU lookup by variant id, populated from the tile dataset.
    var skuByVariant = {};
    tiles.forEach(function (tile) {
      if (tile.dataset.sku) skuByVariant[tile.dataset.variantId] = tile.dataset.sku;
    });
    var amazonBtn = host.querySelector('[data-pdpc-amazon][data-section-id="' + sectionId + '"]');
    // Move the Amazon button INSIDE the standard .product-form__buttons row so
    // it sits side-by-side with Add-to-Cart. The block render position only
    // controls the source order; flex layout takes over here.
    if (amazonBtn) {
      var buyRow = host.querySelector('.product-form__buttons');
      if (buyRow && !buyRow.contains(amazonBtn)) {
        buyRow.classList.add('pdpc-buybar-wrap');
        buyRow.appendChild(amazonBtn);
      }
    }

    function updateAmazonForVariant(variantId) {
      if (!amazonBtn) return;
      var sku = skuByVariant[variantId];
      var url = sku ? amazonMap[sku] : null;
      if (url) {
        amazonBtn.href = url;
        amazonBtn.dataset.sku = sku;
        amazonBtn.hidden = false;
      } else {
        amazonBtn.removeAttribute('href');
        amazonBtn.removeAttribute('data-sku');
        amazonBtn.hidden = true;
      }
    }

    if (initialVariantId) updateAmazonForVariant(initialVariantId);

    // Late-arriving Amazon map (the inline fetch in the snippet may resolve
    // after this controller has booted). Re-apply for the current variant
    // on both the in-page Amazon button AND the sticky bar's Amazon button.
    document.addEventListener('pdpc:amazon-loaded', function (e) {
      if (!e.detail || e.detail.sectionId !== sectionId) return;
      amazonMap = (window.PDPC_AMAZON && window.PDPC_AMAZON[sectionId]) || {};
      var v = currentVariantIdFromOptions();
      updateAmazonForVariant(v);
      if (typeof updateStickyContent === 'function' && v) updateStickyContent(v);
    });

    // ── Sticky Add-to-Cart bar ─────────────────────────────────────────
    // Shown when the natural .product-form__buttons row is off-screen, so
    // the user doesn't have to scroll back down after picking a variant.
    var stickyBar  = document.querySelector('[data-pdpc-sticky][data-section-id="' + sectionId + '"]');
    // Move to <body> so it's anchored to the viewport regardless of any
    // ancestor transform / filter / will-change that would otherwise turn
    // it into the containing block for `position: fixed`.
    if (stickyBar && stickyBar.parentElement !== document.body) {
      document.body.appendChild(stickyBar);
    }
    var stickySku    = stickyBar ? stickyBar.querySelector('[data-pdpc-sticky-sku]') : null;
    var stickyPx     = stickyBar ? stickyBar.querySelector('[data-pdpc-sticky-price]') : null;
    var stickyAtc    = stickyBar ? stickyBar.querySelector('[data-pdpc-sticky-atc]') : null;
    var stickyAmazon = stickyBar ? stickyBar.querySelector('[data-pdpc-sticky-amazon]') : null;

    // In-flow selection bar (sits inside .pdpc-root, just under the tabs).
    // Same purpose as the sticky bar but without the fixed positioning,
    // so the buy CTA is inline with the picker on desktop.
    var selBar      = $('[data-pdpc-selection]', root);
    var selSku      = selBar ? selBar.querySelector('[data-pdpc-selection-sku]') : null;
    var selPx       = selBar ? selBar.querySelector('[data-pdpc-selection-price]') : null;
    var selAtc      = selBar ? selBar.querySelector('[data-pdpc-selection-atc]') : null;
    var selAmazon   = selBar ? selBar.querySelector('[data-pdpc-selection-amazon]') : null;
    var atcInView  = true;

    // ── Back-in-stock waitlist ─────────────────────────────────────────
    var waitlistEl     = $('[data-pdpc-waitlist]', root);
    var waitlistForm   = waitlistEl ? waitlistEl.querySelector('[data-pdpc-waitlist-form]') : null;
    var waitlistEmail  = waitlistEl ? waitlistEl.querySelector('[data-pdpc-waitlist-email]') : null;
    var waitlistSubmit = waitlistEl ? waitlistEl.querySelector('[data-pdpc-waitlist-submit]') : null;
    var waitlistStatus = waitlistEl ? waitlistEl.querySelector('[data-pdpc-waitlist-status]') : null;
    var KLAVIYO_COMPANY_ID = 'TA7T5M';
    var KLAVIYO_NEWSLETTER_LIST_ID = 'XMatLq';

    // Best-effort — failure here shouldn't affect the back-in-stock
    // confirmation the customer actually asked for, so errors are swallowed.
    function subscribeToNewsletter(email) {
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Back in stock waitlist',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: KLAVIYO_NEWSLETTER_LIST_ID } }
            }
          }
        })
      }).catch(function () { /* best effort — waitlist confirmation already shown */ });
    }

    function submitWaitlist(email, variantId) {
      waitlistStatus.dataset.state = '';
      waitlistStatus.textContent = 'Submitting…';
      waitlistSubmit.disabled = true;
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-06-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              channels: ['EMAIL']
            },
            relationships: {
              variant: {
                data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
              }
            }
          }
        })
      }).then(function (r) {
        if (r.status !== 202) throw new Error('HTTP ' + r.status);
        waitlistStatus.dataset.state = 'success';
        waitlistStatus.textContent = 'You’re on the list — we’ll email you when it’s back.';
        waitlistSubmit.textContent = 'Added';
        if (waitlistEmail) waitlistEmail.disabled = true;
        subscribeToNewsletter(email);
      }).catch(function () {
        waitlistStatus.dataset.state = 'error';
        waitlistStatus.textContent = 'Something went wrong. Please try again.';
        waitlistSubmit.disabled = false;
      });
    }

    if (waitlistForm) {
      waitlistForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = waitlistEmail ? waitlistEmail.value.trim() : '';
        var variantId = waitlistEl.dataset.variantId;
        if (!email || !variantId) return;
        submitWaitlist(email, variantId);
      });
    }
    var realAtc    = host.querySelector('button[name="add"]');
    var buyRowEl   = host.querySelector('.product-form__buttons');

    function tileById(vid) {
      for (var i = 0; i < tiles.length; i++) {
        if (tiles[i].dataset.variantId === String(vid)) return tiles[i];
      }
      return null;
    }
    function updateStickyContent(vid) {
      var tile = tileById(vid);
      if (!tile) return;
      var sku = tile.dataset.sku || '';
      var priceEl = tile.querySelector('.pdpc-tile-price');
      var price = priceEl ? priceEl.textContent.trim() : '';
      var unavailable = tile.dataset.available === 'false';
      var preorder = tile.dataset.preorder === 'true';
      var atcLabel = unavailable ? 'Sold out' : (preorder ? 'Pre-order' : 'Add to cart');
      var url = amazonMap[sku] || null;

      // Sticky bar (fixed at viewport bottom).
      if (stickyBar) {
        stickySku.textContent = sku;
        stickyPx.textContent = price;
        stickyAtc.disabled = unavailable;
        stickyAtc.textContent = atcLabel;
        if (stickyAmazon) {
          if (url) { stickyAmazon.href = url; stickyAmazon.dataset.sku = sku; stickyAmazon.hidden = false; }
          else     { stickyAmazon.removeAttribute('href'); stickyAmazon.removeAttribute('data-sku'); stickyAmazon.hidden = true; }
        }
      }
      // Inline selection bar (in-flow, just below the tabs).
      if (selBar) {
        selSku.textContent = sku;
        selPx.textContent = price;
        selAtc.disabled = unavailable;
        selAtc.textContent = atcLabel;
        if (selAmazon) {
          if (url) { selAmazon.href = url; selAmazon.dataset.sku = sku; selAmazon.hidden = false; }
          else     { selAmazon.removeAttribute('href'); selAmazon.removeAttribute('data-sku'); selAmazon.hidden = true; }
        }
      }
      // Back-in-stock waitlist — only for the variant that's actually sold out.
      if (waitlistEl) {
        waitlistEl.hidden = !unavailable;
        if (unavailable && waitlistEl.dataset.variantId !== String(vid)) {
          // Switched to a different sold-out variant — reset any previous submission state.
          waitlistEl.dataset.variantId = vid;
          waitlistStatus.textContent = '';
          waitlistStatus.dataset.state = '';
          waitlistSubmit.disabled = false;
          waitlistSubmit.textContent = 'Notify me';
          if (waitlistEmail) { waitlistEmail.disabled = false; waitlistEmail.value = ''; }
        }
      }
    }
    function refreshStickyVisibility() {
      if (!stickyBar) return;
      var hasSelection = !!document.querySelector('.pdpc-tile[data-selected="true"]');
      stickyBar.hidden = !hasSelection;
    }

    if (stickyAtc && realAtc) {
      stickyAtc.addEventListener('click', function () {
        if (stickyAtc.disabled) return;
        realAtc.click();
      });
    }
    if (selAtc && realAtc) {
      selAtc.addEventListener('click', function () {
        if (selAtc.disabled) return;
        realAtc.click();
      });
    }

    // Hook into our existing variant-change listeners.
    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var v = currentVariantIdFromOptions();
        if (!v) return;
        updateStickyContent(v);
        refreshStickyVisibility();
      });
    });
    if (initialVariantId) updateStickyContent(initialVariantId);
    refreshStickyVisibility();

    // ── Finder ─────────────────────────────────────────────────────────
    var finder = $('.pdpc-finder', root);
    if (finder) initFinder(finder, root, sectionId, skuByVariant, selectTile, setTab, realAtc);
  }

  // Classic → Classic+ upsell, shown in finder results for the SKUs that
  // have a direct Classic+ equivalent. Scoped to the Classic product page
  // only (checked via root.dataset.productHandle) since this JS file is
  // shared across every classic_picker_v2 product.
  var UPSELL_SKU_MAP = { 'DCA-10H': 'COL-10H', 'DCA-10E': 'COL-10E', 'DCA-10B': 'COL-10B' };
  var UPSELL_PRODUCT_HANDLE = 'dongar-classic-1';
  var upsellDataPromise = null;

  function getUpsellData() {
    if (!upsellDataPromise) {
      upsellDataPromise = fetch('/products/' + UPSELL_PRODUCT_HANDLE + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var map = {};
          if (!p || !p.variants) return map;
          p.variants.forEach(function (v) {
            map[v.sku] = {
              id: v.id,
              price: v.price,
              available: v.available,
              preorder: (v.selling_plan_allocations || []).length > 0,
              url: '/products/' + UPSELL_PRODUCT_HANDLE + '?variant=' + v.id
            };
          });
          return map;
        })
        .catch(function () { return {}; });
    }
    return upsellDataPromise;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initFinder(finder, root, sectionId, skuByVariant, selectTile, setTab, realAtc) {
    var makeSel  = $('[data-pdpc-make]',  finder);
    var yearSel  = $('[data-pdpc-year]',  finder);
    var modelSel = $('[data-pdpc-model]', finder);
    var status   = $('.pdpc-finder-status', finder);
    var results  = $('.pdpc-finder-results', finder);
    var redirect = $('.pdpc-finder-redirect', finder);
    var allTiles = $$('.pdpc-tile', root);

    // Warm the Classic+ upsell data in the background so it's ready by the
    // time a matching result renders, rather than fetching cold on first hit.
    if (root.dataset.productHandle === 'dongar-classic') getUpsellData();

    // Pass the current product's SKUs on every finder query so the dropdowns
    // only surface vehicles compatible with one of *this* product's variants.
    // (e.g. on Pro+ the make list narrows to Toyota/Lexus/Mazda, not all 37.)
    var productSkus = Object.keys(skuByVariant)
      .map(function (vid) { return skuByVariant[vid]; })
      .filter(function (s) { return !!s; })
      .join(',');

    function setStatus(html) {
      if (!status) return;
      status.innerHTML = html;
      status.dataset.shown = 'true';
    }
    function clearResults() {
      results.innerHTML = '';
      results.dataset.shown = 'false';
      redirect.dataset.shown = 'false';
    }
    var thisProductTitle = root.dataset.productTitle || 'this product';
    function setRedirect(productUrl, productLabel, sku) {
      if (!redirect) return;
      redirect.innerHTML =
        '<div><h4>This vehicle needs a different adapter</h4>' +
        '<p>SKU <strong>' + escapeHtml(sku) + '</strong> isn’t part of the ' + escapeHtml(thisProductTitle) + '. ' +
        'Check out <strong>' + escapeHtml(productLabel) + '</strong> instead.</p></div>' +
        '<a class="pdpc-redirect-cta" href="' + escapeAttr(productUrl) + '">View product →</a>';
      redirect.dataset.shown = 'true';
    }
    function escapeHtml(s) { return String(s).replace(/[&<>]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' })[c]; }); }
    function escapeAttr(s) { return String(s).replace(/"/g, '&quot;'); }

    // Build a result card for a matched SKU group. `group` is { sku, hits[],
    // tile, trims[] } — multiple compatibility rows can map to the same SKU
    // (e.g. all trims of a model year fit one cable pack), so we collapse
    // them into a single card listing the covered trims.
    function buildResultCard(group) {
      var tile = group.tile;
      var hits = group.hits;
      var card = document.createElement('div');
      card.setAttribute('role', 'button');
      card.tabIndex = 0;
      card.className = 'pdpc-result';
      card.dataset.variantId = tile.dataset.variantId;
      card.dataset.sku = tile.dataset.sku;
      var upsellSku = UPSELL_SKU_MAP[tile.dataset.sku];
      var img = tile.querySelector('.pdpc-tile-img, .pdpc-tile-img-fallback');
      var title = tile.querySelector('.pdpc-tile-title');
      var price = tile.querySelector('.pdpc-tile-price');
      var unavailable = tile.dataset.available === 'false';
      var preorder = tile.dataset.preorder === 'true';
      var atcLabel = unavailable ? 'Sold out' : (preorder ? 'Pre-order' : 'Add to cart');
      var installInfo = (window.DongarInstallInfo && window.DongarInstallInfo.lookup(tile.dataset.sku)) || null;

      // Trims line: list unique submodels covered. Short lists render
      // inline; longer ones (>4) collapse to a teaser with an expand
      // affordance — see trimHtml below.
      var trimSet = {};
      hits.forEach(function (h) {
        var key = [h.submodel1, h.submodel2].filter(Boolean).join(' · ');
        if (key) trimSet[key] = true;
      });
      var trims = Object.keys(trimSet);
      var trimHtml = '';
      if (trims.length === 1) {
        trimHtml = escapeHtml(trims[0]);
      } else if (trims.length >= 2 && trims.length <= 4) {
        trimHtml = 'Fits ' + escapeHtml(trims.join(', '));
      } else if (trims.length > 4) {
        var teaser = 'Fits ' + trims.length + ' trims (' + escapeHtml(trims.slice(0, 2).join(', ')) + ', +' + (trims.length - 2) + ' more)';
        var fullList = 'Fits all ' + trims.length + ' trims: ' + escapeHtml(trims.join(', '));
        trimHtml =
          '<button type="button" class="pdpc-result-trim-toggle" data-pdpc-trim-toggle aria-expanded="false">' +
            '<span class="pdpc-result-trim-teaser">' + teaser + ' <span class="pdpc-result-trim-caret" aria-hidden="true">▾</span></span>' +
            '<span class="pdpc-result-trim-full" hidden>' + fullList + ' <span class="pdpc-result-trim-caret" aria-hidden="true">▴</span></span>' +
          '</button>';
      }

      // Notes: dedupe across hits.
      var noteSet = {};
      hits.forEach(function (h) { if (h.notes) noteSet[h.notes] = true; });
      var notes = Object.keys(noteSet).join(' · ');

      var installHtml = installInfo
        ? '<div class="pdpc-result-install" data-install-type="' + escapeAttr(installInfo.type) + '">' +
            '<svg class="pdpc-result-install-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">' +
              '<path d="M12 22s7-7.5 7-13a7 7 0 1 0-14 0c0 5.5 7 13 7 13z"/><circle cx="12" cy="9" r="2.5"/>' +
            '</svg>' +
            '<div><strong>' + escapeHtml(installInfo.label) + '</strong>' +
            '<span>' + escapeHtml(installInfo.summary) + '</span></div>' +
          '</div>'
        : '';

      card.innerHTML =
        '<div class="pdpc-result-img">' + (img ? img.outerHTML : '') + '</div>' +
        '<div class="pdpc-result-body">' +
          '<div class="pdpc-result-row1">' +
            '<span class="pdpc-result-sku">' + escapeHtml(tile.dataset.sku) + '</span>' +
            '<span class="pdpc-result-price">' + (price ? price.textContent : '') + '</span>' +
          '</div>' +
          '<div class="pdpc-result-title">' + escapeHtml(title ? title.textContent : '') + '</div>' +
          (trimHtml ? '<div class="pdpc-result-trim">' + trimHtml + '</div>' : '') +
          (notes ? '<div class="pdpc-result-notes">' + escapeHtml(notes) + '</div>' : '') +
          (unavailable ? '<div class="pdpc-result-soldout">Currently sold out</div>' : '') +
          installHtml +
          '<button type="button" class="pdpc-result-atc"' + (unavailable ? ' disabled' : '') + '>' + atcLabel + '</button>' +
          (upsellSku
            ? '<button type="button" class="pdpc-upsell-trigger" data-upsell-sku="' + escapeAttr(upsellSku) + '">Upgrade available</button>'
            : '') +
        '</div>' +
        '<span class="pdpc-result-check" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="5 12 10 17 19 8"/></svg>' +
        '</span>';
      card.addEventListener('click', function () {
        markCardActive(card);
        selectTile(tile.dataset.variantId);
      });
      card.addEventListener('keydown', function (e) {
        if (e.target !== card) return; // let nested button/link handle their own Enter/Space
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          markCardActive(card);
          selectTile(tile.dataset.variantId);
        }
      });
      // Expand/collapse the trim list without bubbling to card-selection.
      var toggle = card.querySelector('[data-pdpc-trim-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function (e) {
          e.stopPropagation();
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          toggle.querySelector('.pdpc-result-trim-teaser').hidden = !expanded;
          toggle.querySelector('.pdpc-result-trim-full').hidden = expanded;
        });
      }
      // Explicit add-to-cart — selects this variant and submits immediately,
      // rather than requiring a click on the card followed by a separate
      // click in the buy bar above.
      var atcBtn = card.querySelector('.pdpc-result-atc');
      if (atcBtn) {
        atcBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (atcBtn.disabled) return;
          markCardActive(card);
          selectTile(tile.dataset.variantId);
          if (realAtc) realAtc.click();
        });
      }
      // Desktop-only trigger (hidden on mobile via CSS, where the upsell
      // card already shows inline instead — see buildResultRow). Fetches
      // fresh data at click time rather than waiting on it to render, since
      // the button itself doesn't need price/availability to be clickable.
      var upsellTrigger = card.querySelector('.pdpc-upsell-trigger');
      if (upsellTrigger) {
        upsellTrigger.addEventListener('click', function (e) {
          e.stopPropagation();
          getUpsellData().then(function (map) {
            var info = map[upsellTrigger.dataset.upsellSku];
            if (!info) return;
            openUpsellModal(upsellTrigger.dataset.upsellSku, info, upsellTrigger);
          });
        });
      }
      return card;
    }

    function openUpsellModal(sku, info, opener) {
      var modal = document.getElementById('ClassicUpsellModal');
      var body = modal ? modal.querySelector('[data-pdpc-upsell-modal-body]') : null;
      if (!modal || !body) return;
      body.innerHTML = '';
      body.appendChild(buildUpsellCard(sku, info));
      modal.show(opener);
    }

    function buildUpsellCard(sku, info) {
      var el = document.createElement('div');
      el.className = 'pdpc-upsell';
      var label = info.available === false ? 'Out of stock' : (info.preorder ? 'Pre-order Classic+' : 'Buy Classic+');
      var disabled = info.available === false;
      // The global pre-order acknowledgment gate (preorder-ack.js) finds
      // preorder variant IDs by scanning the DOM for this attribute — which
      // otherwise only covers the current page's own product. Tag this
      // card directly so the gate still catches a Classic+ variant added
      // from the Classic page.
      if (info.preorder) el.setAttribute('data-preorder-variant-ids', String(info.id) + ',');
      el.innerHTML =
        '<p class="pdpc-upsell-eyebrow">Want the upgraded version?</p>' +
        '<div class="pdpc-upsell-row1">' +
          '<span class="pdpc-upsell-title">Classic+ (' + escapeHtml(sku) + ')</span>' +
          '<span class="pdpc-upsell-price">' + formatMoney(info.price) + '</span>' +
        '</div>' +
        '<p class="pdpc-upsell-text">Same fit and installation, with an added OLED display for real-time power monitoring.</p>' +
        '<div class="pdpc-upsell-actions">' +
          '<button type="button" class="pdpc-upsell-buy"' + (disabled ? ' disabled' : '') + '>' + label + '</button>' +
          '<a class="pdpc-upsell-learn" href="' + escapeAttr(info.url) + '">Learn more</a>' +
        '</div>';
      var buyBtn = el.querySelector('.pdpc-upsell-buy');
      buyBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (buyBtn.disabled) return;
        // If this triggers the site-wide pre-order acknowledgment modal
        // (preorder-ack.js), close this one first rather than stacking
        // one modal on top of another.
        if (info.preorder) {
          var upsellModal = document.getElementById('ClassicUpsellModal');
          if (upsellModal) upsellModal.hide();
        }
        var originalLabel = buyBtn.textContent;
        buyBtn.disabled = true;
        buyBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: info.id, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          buyBtn.textContent = 'Added';
        }).catch(function () {
          buyBtn.textContent = originalLabel;
          buyBtn.disabled = false;
        });
      });
      return el;
    }

    function buildResultRow(group) {
      var row = document.createElement('div');
      row.className = 'pdpc-result-row';
      row.appendChild(buildResultCard(group));

      var upsellSku = UPSELL_SKU_MAP[group.tile.dataset.sku];
      if (upsellSku && root.dataset.productHandle === 'dongar-classic') {
        getUpsellData().then(function (map) {
          var info = map[upsellSku];
          if (!info) return;
          row.appendChild(buildUpsellCard(upsellSku, info));
        });
      }
      return row;
    }

    function markCardActive(card) {
      $$('.pdpc-result', results).forEach(function (c) { c.dataset.active = c === card ? 'true' : 'false'; });
    }

    function fillSelect(sel, items, placeholder) {
      sel.innerHTML = '';
      var opt = document.createElement('option');
      opt.value = '';
      opt.textContent = placeholder;
      sel.appendChild(opt);
      items.forEach(function (it) {
        var o = document.createElement('option');
        o.value = String(it);
        o.textContent = String(it);
        sel.appendChild(o);
      });
      sel.disabled = false;
    }

    api({ action: 'makes', skus: productSkus }).then(function (d) {
      fillSelect(makeSel, d.makes || [], 'Select make');
    }).catch(function () {
      setStatus('<strong>Couldn’t load makes.</strong> Please refresh.');
    });

    makeSel.addEventListener('change', function () {
      yearSel.disabled = true; yearSel.innerHTML = '<option>Year</option>';
      modelSel.disabled = true; modelSel.innerHTML = '<option>Model</option>';
      status.dataset.shown = 'false'; clearResults();
      if (!makeSel.value) return;
      api({ action: 'years', make: makeSel.value, skus: productSkus }).then(function (d) {
        fillSelect(yearSel, d.years || [], 'Select year');
      });
    });

    yearSel.addEventListener('change', function () {
      modelSel.disabled = true; modelSel.innerHTML = '<option>Model</option>';
      status.dataset.shown = 'false'; clearResults();
      if (!yearSel.value) return;
      api({ action: 'models', make: makeSel.value, year: yearSel.value, skus: productSkus }).then(function (d) {
        fillSelect(modelSel, d.models || [], 'Select model');
      });
    });

    modelSel.addEventListener('change', function () {
      if (!modelSel.value) return;
      runSearch();
    });

    function tileForSku(sku) {
      for (var i = 0; i < allTiles.length; i++) {
        if (allTiles[i].dataset.sku === sku) return allTiles[i];
      }
      return null;
    }

    function runSearch() {
      clearResults();
      setStatus('Searching…');
      api({
        action: 'search',
        make: makeSel.value, year: yearSel.value, model: modelSel.value,
        skus: productSkus
      }).then(function (d) {
        var rows = (d && d.data) || [];
        if (!rows.length) {
          setStatus('<strong>No match found.</strong> Try a different model, or contact support.');
          return;
        }

        // Split hits into in-product (this Classic) vs out-of-product
        // (Pro / Universal etc.), then group in-product hits by SKU. Many
        // trims of the same model often map to one cable pack — collapsing
        // those into a single card cuts noise.
        var groupsBySku = {};
        var groupOrder = [];
        var outOfProduct = [];
        rows.forEach(function (hit) {
          var tile = tileForSku(hit.sku);
          if (!tile) { outOfProduct.push(hit); return; }
          if (!groupsBySku[hit.sku]) {
            groupsBySku[hit.sku] = { sku: hit.sku, tile: tile, hits: [] };
            groupOrder.push(hit.sku);
          }
          groupsBySku[hit.sku].hits.push(hit);
        });
        var groups = groupOrder.map(function (sku) { return groupsBySku[sku]; });

        if (groups.length) {
          var label = makeSel.value + ' ' + modelSel.value + (yearSel.value ? ' (' + yearSel.value + ')' : '');
          var headline = groups.length === 1
            ? '<strong>Match found for your ' + escapeHtml(label) + '</strong>'
            : '<strong>' + groups.length + ' compatible cable packs for your ' + escapeHtml(label) + '</strong>' +
              '<span class="pdpc-result-hint">Pick the one matching your trim — or just go with the first.</span>';
          setStatus(headline);

          groups.forEach(function (g) {
            results.appendChild(buildResultRow(g));
          });
          results.dataset.shown = 'true';

          // Auto-select the first group so the buy box (price, ATC, Amazon)
          // is wired to the right variant immediately.
          var firstCard = results.querySelector('.pdpc-result');
          if (firstCard) {
            markCardActive(firstCard);
            selectTile(firstCard.dataset.variantId);
          }
          return;
        }

        // No matches in this product — point to the right product.
        var sku = outOfProduct[0].sku;
        api({ action: 'products', skus: sku }).then(function (pd) {
          var p = (pd.products || [])[0];
          if (p && p.product_url) {
            status.dataset.shown = 'false';
            setRedirect(p.product_url, p.title || sku, sku);
          } else {
            setStatus(
              '<strong>SKU ' + escapeHtml(sku) + '</strong> ' +
              'isn’t part of Dongar Classic. ' +
              '<a href="/pages/fit-finder">Open the full finder →</a>'
            );
          }
        });
      }).catch(function () {
        setStatus('<strong>Search failed.</strong> Please try again.');
      });
    }
  }

  // Boot
  function boot() {
    $$('.pdpc-root').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Outbound Amazon-click logging. One delegated listener covers all three
  // button surfaces (main buy row, sticky bar, in-flow selection bar). Uses
  // keepalive so the request survives the imminent navigation to Amazon.
  document.addEventListener('click', function (e) {
    var a = e.target.closest(
      'a[data-pdpc-amazon], a[data-pdpc-sticky-amazon], a[data-pdpc-selection-amazon]'
    );
    if (!a || !a.href) return;
    try {
      fetch(API_BASE + '?action=log_event', {
        method: 'POST',
        keepalive: true,
        headers: ANON
          ? { 'Content-Type': 'application/json', 'apikey': ANON, 'Authorization': 'Bearer ' + ANON }
          : { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event_type: 'amazon_click',
          sku: a.dataset.sku || null,
          /* Resolved traffic source + Attribution bucket for analytics
             (finder-attribution.js, loaded site-wide). The outbound URL itself
             already carries the website_product Attribution tag from the DB, so
             it is unchanged. */
          source: (window.DongarAttribution && window.DongarAttribution.source()) || null,
          bucket: (window.DongarAttribution && window.DongarAttribution.bucket
            ? window.DongarAttribution.bucket() : null) || null
        })
      });
    } catch (err) { /* never block navigation */ }
  }, true);
})();
